import React from 'react';
import { bool, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useIntl } from '../../../../util/reactIntl';

import Field, { hasDataInFields } from '../../Field';
import SectionContainer from '../SectionContainer';
import css from './SectionHero.module.css';

const SectionHero = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    options,
  } = props;

  const intl = useIntl();
  const currentUser = useSelector(state => state.user.currentUser);

  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);

  const userType = currentUser?.attributes?.profile?.publicData?.userType;
  const isClient = userType === 'clientes-id';

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const labelDefault = intl.formatMessage({
    id: 'SectionHero.cta.default',
    defaultMessage: 'Buscar oportunidades',
  });
  const labelClients = intl.formatMessage({
    id: 'SectionHero.cta.clients',
    defaultMessage: 'Buscar consultores',
  });

  const ctaLabel = isClient ? labelClients : labelDefault;
  const ctaHref = callToAction?.href || callToAction?.to || '/s';

  const longestLen = Math.max(labelDefault.length, labelClients.length);
  const minWidthCh = longestLen + 2;
  const ctaStyle = { minWidth: `${minWidthCh}ch` };

  // ✅ Fondo por rol usando PUBLIC_URL (no pasa por Webpack en CSS)
  const bgUrl = `${process.env.PUBLIC_URL}${
    isClient ? '/img/banners/company-hero.jpg' : '/img/banners/consultant-hero.jpg'
  }`;
  const bgStyle = { backgroundImage: `url(${bgUrl})` };

  const bannerClass = isClient ? css.clientBg : css.consultantBg;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={classNames(rootClassName || css.root, bannerClass)}
      appearance={appearance}
      options={fieldOptions}
      /* ⬇️ aplica el background aquí */
      style={bgStyle}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />

          <a
            className={classNames(defaultClasses.ctaButton, !mounted ? css.ctaInvisible : null)}
            href={ctaHref}
            aria-label={ctaLabel}
            style={ctaStyle}
          >
            {ctaLabel}
          </a>
        </header>
      ) : null}
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionHero.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  isInsideContainer: false,
  options: null,
};

SectionHero.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionHero;
